// tslint:disable
// add manually written custom queries that amplify codegen does not generate here

// This cannot be larger than 1000, see https://github.com/aws-amplify/amplify-cli/issues/1496
export const maxAWSItemLimit = 1000;
export const getAssessmentRequestWithDoctor = `query GetAssessmentRequestWithDoctor($id: ID!) {
  getAssessmentRequest(id: $id) {
    id
    type
    doctor {
      id
      firstName
      lastName
      email
      emailVerified
      cognitoGroups
      practitionerId
      clinic {
        id
      }
    }
    recipient {
      id
      firstName
      lastName
      email
      emailVerified
      practitionerId
    }
    assessment {
      id
      patient {
        id
      }
      doctor {
        id
        firstName
        lastName
        email
        emailVerified
        practitionerId
        clinic {
          id
        }
      }
      type
      body
      attachments {
        bucket
        key
        region
        fileName
      }
    }
    response
    createdAt
    updatedAt
  }
}
`;

export const getAllInfo = /* GraphQL */ `
  query GetAllInfo {
    me {
      id
      firstName
      lastName
      email
      emailVerified
      agreedToTerms
      staffType
      allowMultipleClinics
      ownedClinics
      displayedNameFormat
      doctorDegree
      doctorSignature {
        drawn
        typed
        uploaded {
          bucket
          key
          region
          fileName
        }
      }
      preferredLanguage
      clinic {
        id
        name
        address
        province
        country
        postalCode
        city
        phone
        fax
        logo {
          bucket
          key
          region
          fileName
        }
        doctors {
          items {
            id
            email
            practitionerId
            firstName
            lastName
          }
          nextToken
        }
        emrIntegration {
          fax {
            enabled
            faxNumber
          }
        }
        referralCenter {
          id
          name
          referralCenterClinicId
          diseaseAreas
          notificationRecipients
          logo {
            bucket
            key
            region
            fileName
          }
          referralForms {
            name
            file {
              bucket
              key
              region
              fileName
            }
            type
          }
          agreement
          educationEmbedLink
          advancedReferralCenter
        }
        linkedReferralCenter {
          id
          name
          referralCenterClinicId
          diseaseAreas
          logo {
            bucket
            key
            region
            fileName
          }
          referralForms {
            name
            file {
              bucket
              key
              region
              fileName
            }
            type
          }
          agreement
          educationEmbedLink
          advancedReferralCenter
        }
        owner {
          id
          firstName
          lastName
          email
          emailVerified
          agreedToTerms
          cognitoGroups
          practitionerId
          createdAt
          updatedAt
        }
        patients {
          nextToken
        }
        stripeInformation {
          subscriptionId
          customerId
          lastDigitsOfCard
          nextPaymentDate
          nameOnCard
          subscriptionStatus
        }
        clinicSetup {
          id
          clinicSetupClinicId
          createdAt
          updatedAt
          layouts {
            id
            name
            alwaysExpand
            signsLayout {
              show
              hide
            }
            medicalHistoryLayout {
              show
              hide
            }
            symptomSettings
            customLayout
          }
          hiddenTextFavorites
          hiddenTreatmentTemplates
          interactionsSetup
          aiScribeSetup
          defaultQuestionnaireLanguage
          textFavoriteConfig
          defaultPdfLanguage
          temperatureUnit
          welcomeMessageConfig
          emailNotificationsConfig
          questionnaireExpiry
          questionnaireScoreConfig
          questionnaireNotificationsConfig
          reminderConfig
          subscriptionPlan
          subscriptionPlanAddOns
          extraConfig
        }
        clinicFormTemplates {
          items {
            id
            schema
            formTemplateClinicId
            createdAt
            updatedAt
          }
          nextToken
        }
        agreedToTermsOfService
        createdAt
        updatedAt
      }
      cognitoGroups
      patients {
        items {
          id
          firstName
          lastName
          email
          emailVerified
          phone
          agreedToTerms
          dateOfBirth
          gender
          address
          consentsToResearch
          consentsToPrivacyForm
          consentSource
          createdAt
          updatedAt
        }
        nextToken
      }
      practitionerId
      assessments {
        items {
          id
          type
          body
          locked
          createdAt
          updatedAt
        }
        nextToken
      }
      assessmentRequests {
        items {
          id
          type
          response
          priority
          createdAt
          updatedAt
        }
        nextToken
      }
      inboundAssessmentRequests {
        items {
          id
          type
          response
          priority
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

export const lockAssessment = `mutation LockAssessment($input: UpdateAssessmentInput!) {
  updateAssessment(input: $input) {
    id
    locked
  }
}`;

export const medicationLookup = `query MedicationLookupCustom($query: String!) {
  searchMedications(query: $query) {
    products {
      _id
      ndc_product_codes
      dpd_codes
      ema_product_codes
      name
      rx_norm_prescribable_name
      country
      route
      dosage_form
      ingredients {
        drugbank_id
        name
        strength {
          number
          unit
        }
      }
    }
  }
}
`;

export const getQuestionnaireRequestWithResponse = `
  query getQuestionnaireRequestWithResponseAndCompletedAt($id: ID!) {
    getQuestionnaireRequest(id: $id) {
      completedAt
      response {
        answers
        scores
      }
      config
    }
  }
`;

export const getAllClinic = /* GraphQL */ `
  query GetAllClinic($id: ID!) {
    getClinic(id: $id) {
      id
      name
      address
      province
      country
      city
      postalCode
      phone
      fax
      logo {
        bucket
        key
        region
        fileName
      }
      doctors {
        items {
          id
          firstName
          lastName
          email
          emailVerified
          agreedToTerms
          cognitoGroups
          practitionerId
          createdAt
          updatedAt
          deactivated
          staffType
        }
        nextToken
      }
      owner {
        id
        firstName
        lastName
        email
        emailVerified
        agreedToTerms
        cognitoGroups
        patients {
          nextToken
        }
        practitionerId
        assessments {
          nextToken
        }
        assessmentRequests {
          nextToken
        }
        inboundAssessmentRequests {
          nextToken
        }
        createdAt
        updatedAt
        deactivated
        staffType
      }
      patients {
        items {
          id
          firstName
          lastName
          email
          emailVerified
          phone
          agreedToTerms
          dateOfBirth
          gender
          address
          consentsToResearch
          consentsToPrivacyForm
          consentSource
          createdAt
          updatedAt
        }
        nextToken
      }
      emrIntegration {
        fax {
          enabled
          faxNumber
        }
      }
      clinicSetup {
        id
        clinicSetupClinicId
        createdAt
        updatedAt
        layouts {
          id
          name
          alwaysExpand
          signsLayout {
            show
            hide
          }
          medicalHistoryLayout {
            show
            hide
          }
          symptomSettings
        }
        defaultQuestionnaireLanguage
        defaultPdfLanguage
        welcomeMessageConfig
      }
      createdAt
      updatedAt
    }
  }
`;

export const getAllAssessmentInfo = /* GraphQL */ `
  query GetAllAssessmentInfo($id: ID!) {
    getAssessment(id: $id) {
      id
      doctor {
        id
      }
      clinic {
        id
      }
      patient {
        id
      }
      assessmentClinicId
      type
      body
      attachments {
        bucket
        key
        region
        fileName
        metadata
      }
      locked
      createdAt
      updatedAt
      questionnaireRequests {
        items {
          id
          email
          mobile
          questionnaireRequestPatientId
          type
          country
          consentsToPrivacyForm
          consentSource
          consentsToResearch
          completedAt
          createdAt
          updatedAt
          nonModifiableData
          config
          response {
            answers
            scores
            consent {
              consentsToPrivacyForm
              consentsToResearch
              agreedToTerms
              consentSource
            }
          }
        }
        nextToken
      }
    }
  }
`;

// ─── Day Sheets ───────────────────────────────────────────────────────────────
// Hand-written queries that will not be overwritten by `amplify codegen`.
// Variable names match the @key field names defined in schema.graphql.

export const listDaySheetPatientsByClinicAndDate = /* GraphQL */ `
  query ListDaySheetPatientsByClinicAndDate(
    $daySheetPatientClinicId: ID
    $daySheetDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDaySheetPatientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDaySheetPatientsByClinicAndDaySheetDate(
      daySheetPatientClinicId: $daySheetPatientClinicId
      daySheetDate: $daySheetDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        daySheetDate
        daySheetPatientClinicId
        daySheetPatientTemplateId
        daySheetPatientAssessmentId
        patientId
      }
      nextToken
    }
  }
`;

export const getDaySheetPatientBasic = /* GraphQL */ `
  query GetDaySheetPatientBasic($id: ID!) {
    getDaySheetPatient(id: $id) {
      id
      daySheetDate
      daySheetPatientClinicId
      daySheetPatientTemplateId
      daySheetPatientAssessmentId
      patientId
    }
  }
`;

export const listDaySheetPatientDatesByClinicAndMonth = /* GraphQL */ `
  query ListDaySheetPatientDatesByClinicAndMonth(
    $daySheetPatientClinicId: ID
    $date: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
  ) {
    listDaySheetPatientsByClinicAndDaySheetDate(
      daySheetPatientClinicId: $daySheetPatientClinicId
      daySheetDate: $date
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        daySheetDate
      }
      nextToken
    }
  }
`;

export const createDaySheetPatient = /* GraphQL */ `
  mutation CreateDaySheetPatient($input: CreateDaySheetPatientInput!) {
    createDaySheetPatient(input: $input) {
      id
      daySheetDate
      daySheetPatientClinicId
      daySheetPatientTemplateId
      daySheetPatientAssessmentId
      patientId
    }
  }
`;

export const updateDaySheetPatient = /* GraphQL */ `
  mutation UpdateDaySheetPatient($input: UpdateDaySheetPatientInput!) {
    updateDaySheetPatient(input: $input) {
      id
      daySheetPatientAssessmentId
    }
  }
`;


export const getDaySheetTemplateById = /* GraphQL */ `
  query GetDaySheetTemplate($id: ID!) {
    getDaySheetTemplate(id: $id) {
      id
      daySheetTemplateClinicSetupId
      daySheetTemplateClinicId
      name
      questionnaires
      assessmentType
      signs
    }
  }
`;

export const listDaySheetTemplatesByClinicSetupId = /* GraphQL */ `
  query ListDaySheetTemplatesByClinicSetupId(
    $clinicSetupId: ID
    $filter: ModelDaySheetTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDaySheetTemplatesByClinicSetupId(
      daySheetTemplateClinicSetupId: $clinicSetupId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        daySheetTemplateClinicSetupId
        daySheetTemplateClinicId
        name
        questionnaires
        assessmentType
        signs
      }
      nextToken
    }
  }
`;

export const createDaySheetTemplate = /* GraphQL */ `
  mutation CreateDaySheetTemplate($input: CreateDaySheetTemplateInput!) {
    createDaySheetTemplate(input: $input) {
      id
      daySheetTemplateClinicSetupId
      daySheetTemplateClinicId
      name
      questionnaires
      assessmentType
      signs
    }
  }
`;

export const updateDaySheetTemplate = /* GraphQL */ `
  mutation UpdateDaySheetTemplate($input: UpdateDaySheetTemplateInput!) {
    updateDaySheetTemplate(input: $input) {
      id
      name
      questionnaires
      assessmentType
      signs
    }
  }
`;
